const eventClickNews = (params) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: `promotionClick`,
      eventCategory: `ecommerce promotion`,
      eventLabel: `${(params?.anotherCategory
        ? params?.anotherCategory
        : params?.category
      ).toLowerCase()}`,
      ecommerce: {
        promoClick: {
          promotions: [
            {
              id: `${params?.id}`,
              name: `${params?.title?.toLowerCase() || 'Tidak Tersedia'}`,
              creative: `${params?.anotherCategory === 'berita & tips' || params?.baseSlug === '/berita-dan-tips' ? '/berita-dan-tips/' : params?.baseSlug?.toLowerCase()}${params?.slug?.toLowerCase()}`,
              position: `${params?.index} - ${
                params?.baseSlug === '/berita-dan-tips' ||
                params?.anotherCategory === 'berita & tips'
                  ? 'berita & tips'
                  : params?.baseSlug?.slice(1)?.replace(/-/g, ' ')
              } ${params?.category.toLowerCase()}`,
            },
          ],
        },
      },
    });
  }
};
export default eventClickNews;
